import { post, postJson,get,put,deleteApi } from '../axios'

const RESOURCE_BASE_PATH = '/jdCusuffix'


/***
 * 查询所有签名
 * @param p
 */
export const queryAllSellerCusuffix = p => get(`${RESOURCE_BASE_PATH}/list`, p);


/***
 * 重新提交
 * @param p
 */
export const reput = p => put(`${RESOURCE_BASE_PATH}/reput/`+p.id);



/***
 * 插入签名
 * @param p
 */
export const insert = p => postJson(`${RESOURCE_BASE_PATH}/insert`, p);


/***
 * 编辑签名
 * @param p
 */
export const editCount = p => put(`${RESOURCE_BASE_PATH}/`, p);


/***
 * 设置默认
 * @param p
 */
export const def = p => put(`${RESOURCE_BASE_PATH}/def`, p);


/***
 * 删除签名
 * @param p
 */
export const delectCount = p => deleteApi(`${RESOURCE_BASE_PATH}/`+p.id);





// /***
//  * 增加签名
//  * @param p
//  */
// export const addSellerCusuffix = p => post(`${RESOURCE_BASE_PATH}/SellerCusuffix/addSellerCusuffix`, p)


// /***
//  * 删除某一条店铺签名
//  * @param p
//  */
// export const delSellerCusuffix = p => post(`${RESOURCE_BASE_PATH}/SellerCusuffix/delSellerCusuffix`, p)





// /***
//  * 更新某一条店铺签名
//  * @param p
//  */
// export const updateSellerCusuffix  = p => post(`${RESOURCE_BASE_PATH}/SellerCusuffix/updateSellerCusuffix `, p)


// /***
//  * 默认店铺签名
//  * @param p
//  */
// export const updateSellerCusuffixToFirst  = p => post(`${RESOURCE_BASE_PATH}/SellerCusuffix/updateSellerCusuffixToFirst`, p)





